export const branchDefaultValues = (carrierId: number) => ({
  Id: 0,
  BranchGsdb: "",
  CarrierReference: "",
  Name: "",
  ImcsCode: "",
  TimeZone: "",
  Type: "",
  Area: "",
  Region: "",
  Street: "",
  City: "",
  Zip: "",
  CountryId: 0,
  CountryIsoCode: "",
  CarrierId: carrierId,

  IsNewBranch: true,
});
